export default __webpack_public_path__ + "7bb84c1849976c53d2acca814e5a2fb0.png";